import ButtonLink from '@components/common/Button/ButtonLink'
import ProgressBar from '@components/common/ProgressBar/ProgressBar'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'

import MotionText from '@/components/common/Motion/MotionText'

import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { usePageSetup } from '@/hooks/usePageSetup'

import { useEffect } from 'react'
import { useKycStore } from '@store/useKycStore'

export const KycVehiclePage = () => {
  const { t } = useTranslation()
  usePageSetup(t('kyc.pageTitle.vehicle'), { scroll: true })

  const progress = useKycStore((state) => state.progress)
  const setProgress = useKycStore((state) => state.setProgress)

  useEffect(() => setProgress(4), [])

  return (
    <div className="h-full bg-white p-5 pb-8 flex flex-col">
      <HeaderBack className='items-center gap-4'>
        <ProgressBar
          currentStep={progress}
          totalSteps={8}
        />
      </HeaderBack>

      <div className="flex-1 flex flex-col mt-4">
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-zinc-900 text-3xl font-bold leading-tight"
            delay={0.2}
          >
            {t('kyc.vehicle.title')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.4}
          >
            {t('kyc.vehicle.description')}
          </MotionText>
        </div>
      </div>

      <motion.div className="space-y-4 flex flex-col">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='primary' to={'/kyc/vat'}>
            {t('kyc.vehicle.yesRegistered')}
          </ButtonLink>
        </motion.div>
        <ButtonLink variant='secondary' to={'/kyc/vehicle/how'}>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: "easeOut"
            }}
          >
            {t('kyc.vehicle.howToRegister')}
          </motion.span>
        </ButtonLink>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='tertiary' to={'/kyc/vat'}>
            {t('kyc.vehicle.doLater')}
          </ButtonLink>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default KycVehiclePage